import { MouseEvent, ReactNode, useRef } from 'react';
import styled from 'styled-components';
import { Portal } from '../portal';

const StyledTray = styled.div`
	box-sizing: border-box;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.4);
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	padding: 10px;
	pointer-events: all;
`;

interface TrayProps {
	onBackdropClick?: (event: MouseEvent) => void;
	children: ReactNode;
}

export function Tray({ onBackdropClick, children }: TrayProps): JSX.Element {
	const ref = useRef<HTMLDivElement>(null);

	function handleClick(event: MouseEvent): void {
		if (event.target === ref.current && onBackdropClick != null) {
			onBackdropClick(event);
		}
	}

	return (
		<Portal>
			<StyledTray ref={ref} onClick={handleClick}>
				{children}
			</StyledTray>
		</Portal>
	);
}

Tray.displayName = 'CellulaTray';
